import { userStore } from '@/store';
import { ADMIN_USER_TYPE } from '@/configs/user';

/**
 * システム管理者判定
 */
export const isSystemAdmin = (): boolean => {
  return userStore.loginUser.user_type === ADMIN_USER_TYPE.SYSTEM_ADMIN;
};
